import { render, staticRenderFns } from "./OrganizationLogo.vue?vue&type=template&id=59fa8d95"
import script from "./OrganizationLogo.vue?vue&type=script&lang=js"
export * from "./OrganizationLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports